module.exports = __webpack_public_path__ + "static/circle-semi-1-0ce972f70bbd2df73de40734a6fca814.png";